import { z } from 'zod';
import { agentTemplateKindSchema } from './agents.js';
// Mirrors toolDefinitionStatusEnum in @reach/database; shared-types cannot depend on that package.
export const agentTemplateGrantToolStatusSchema = z.enum(['active', 'inactive']);
export const agentTemplateGrantSchema = z.object({
    grantId: z.string().uuid(),
    toolDefinitionId: z.string().uuid().nullable(),
    systemToolName: z.string().nullable(),
    toolName: z.string().nullable(),
    toolDisplayName: z.string().nullable(),
    toolStatus: agentTemplateGrantToolStatusSchema.nullable(),
});
export const agentTemplateSchema = z.object({
    id: z.string().uuid(),
    kind: agentTemplateKindSchema,
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
    grants: z.array(agentTemplateGrantSchema),
});
export const agentTemplateCreatedGrantSchema = z.object({
    grantId: z.string().uuid(),
    toolDefinitionId: z.string().uuid().nullable(),
    systemToolName: z.string().nullable(),
});
export const agentTemplateAddGrantBodySchema = z
    .object({
    toolDefinitionId: z.string().uuid().optional(),
    systemToolName: z.string().min(1).optional(),
})
    .refine(body => (body.toolDefinitionId === undefined) !== (body.systemToolName === undefined), {
    message: 'Provide exactly one of toolDefinitionId or systemToolName',
});
export const agentTemplateTenantCountSchema = z.object({
    tenantCount: z.number().int(),
});
/** `data.code` on the error envelope when a grant committed but the Voice sync job could not be queued. */
export const AGENT_TEMPLATE_VOICE_SYNC_ENQUEUE_FAILED_CODE = 'AGENT_TEMPLATE_VOICE_SYNC_ENQUEUE_FAILED';
//# sourceMappingURL=agent-templates.js.map